module.exports = __webpack_public_path__ + "img/1F4A7.460adde4.svg";